import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  VStack,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import {
  FaCog,
  FaDatabase,
  FaMobile,
  FaDesktop,
  FaHeadset,
  FaRocket,
} from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const ServicesSection: React.FC = () => {
  const { t, ready } = useTranslation();
  const cardBg = useColorModeValue('white', 'gray.700');

  const services = [
    {
      title: t('servicesSection.customDevelopment.title'),
      description: t('servicesSection.customDevelopment.description'),
      icon: FaCog,
    },
    {
      title: t('servicesSection.integrationServices.title'),
      description: t('servicesSection.integrationServices.description'),
      icon: FaDatabase,
    },
    {
      title: t('servicesSection.mobileSolutions.title'),
      description: t('servicesSection.mobileSolutions.description'),
      icon: FaMobile,
    },
    {
      title: t('servicesSection.desktopApplications.title'),
      description: t('servicesSection.desktopApplications.description'),
      icon: FaDesktop,
    },
    {
      title: t('servicesSection.support247.title'),
      description: t('servicesSection.support247.description'),
      icon: FaHeadset,
    },
    {
      title: t('servicesSection.consulting.title'),
      description: t('servicesSection.consulting.description'),
      icon: FaRocket,
    },
  ];

  if (!ready) {
    return null;
  }

  return (
    <Box
      bg={useColorModeValue('gray.50', 'gray.800')}
      py={{ base: 12, md: 16 }}
    >
      <Container maxW='7xl'>
        <VStack spacing={{ base: 8, md: 12 }}>
          <VStack spacing={4} textAlign='center'>
            <Heading size={{ base: 'xl', md: '2xl' }} color='primary.500'>
              {t('servicesSection.title')}
            </Heading>
            <Text
              fontSize={{ base: 'md', md: 'lg' }}
              color='gray.500'
              maxW='2xl'
            >
              {t('servicesSection.subtitle')}
            </Text>
          </VStack>

          <SimpleGrid
            columns={{ base: 1, md: 2, lg: 3 }}
            spacing={{ base: 6, md: 8 }}
          >
            {services.map((service, index) => (
              <Box
                key={index}
                bg={cardBg}
                p={{ base: 4, md: 6 }}
                borderRadius='lg'
                textAlign='center'
                boxShadow='md'
                border='1px solid'
                borderColor={useColorModeValue('gray.200', 'gray.600')}
                _hover={{ transform: 'translateY(-2px)', boxShadow: 'lg' }}
                transition='all 0.3s'
              >
                <VStack spacing={{ base: 3, md: 4 }}>
                  <Icon
                    as={service.icon}
                    boxSize={{ base: 10, md: 12 }}
                    color='primary.500'
                  />
                  <Heading
                    color={useColorModeValue('gray.900', 'white')}
                    size={{ base: 'sm', md: 'md' }}
                  >
                    {service.title}
                  </Heading>
                  <Text
                    color={useColorModeValue('gray.600', 'gray.400')}
                    fontSize={{ base: 'xs', md: 'sm' }}
                  >
                    {service.description}
                  </Text>
                </VStack>
              </Box>
            ))}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>
  );
};

export default ServicesSection;
